<template lang="pug">
.plan-function-detail-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer scrollable)
    template(#modal-header="{ cancel }")
      .plan-function-detail-modal-header
        span 契約プランの機能比較の詳細
      button.close(type="button" @click="cancel") ×
    .plan-function-detail-modal-body
      .title プラン機能比較表
      .plan-function-detail-modal-table
        .thead
          .header-line
            .th.item 項目
            .th.free フリー
            .th.light ライト
            .th.basic ベーシック
        .tbody
          .body-line
            .td.item 家族への連絡
            .td.free
              div
                span.limited △
                span.detail （テキストのみ）
            .td.light
              div
                span.full 〇
                span.detail （テキスト／写真／動画／PDF）
            .td.basic
              div
                span.full 〇
                span.detail （テキスト／写真／動画／PDF）
          .body-line
            .td.item 家族からの連絡
            .td.free.full 〇
            .td.light.full 〇
            .td.basic.full 〇
          .body-line
            .td.item オンライン面会・訪問面会予約
            .td.free.full 〇
            .td.light.full 〇
            .td.basic.full 〇
          .body-line
            .td.item 外出外泊届け
            .td.free ×
            .td.light.full 〇
            .td.basic.full 〇
          .body-line
            .td.item 利用者グループ・宛先グループ管理
            .td.free ×
            .td.light.full 〇
            .td.basic.full 〇
          .body-line
            .td.item 通知設定（メール通知）
            .td.free ×
            .td.light.full 〇
            .td.basic.full 〇
          .body-line
            .td.item カレンダー・履歴の確認
            .td.free ×
            .td.light.full 〇
            .td.basic.full 〇
          .body-line
            .td.item アンケート
            .td.free ×
            .td.light ×
            .td.basic.full 〇
          .body-line
            .td.item 文書送付・同意取得
            .td.free ×
            .td.light ×
            .td.basic.full 〇
          .body-line
            .td.item 介護記録
            .td.free ×
            .td.light ×
            .td.basic.full 〇
          .body-line
            .td.item
              div
                span イベント情報の案内
                br
                span 参加申込み・ライブ配信
            .td.free ×
            .td.light ×
            .td.basic.full 〇
          .body-line
            .td.item 写真印刷依頼（家族からの写真送付）
            .td.free ×
            .td.light ×
            .td.basic.full 〇
          .body-line
            .td.item 施設関係者との連絡
            .td.free ×
            .td.light ×
            .td.basic.full 〇
          .body-line
            .td.item 安否確認
            .td.free ×
            .td.light ×
            .td.basic.full 〇
          .body-line
            .td.item
              div
                span 部屋スケジュール管理
                br
                span ケアマネ等への空床情報提供
            .td.free ×
            .td.light ×
            .td.basic.full 〇
          .body-line
            .td.item 医療機関等との情報連携
            .td.free ×
            .td.light.full 〇
            .td.basic.full 〇
          .body-line
            .td.item 施設アプリユーザー数
            .td.free
              div
                span.limited 1
                span.detail （管理者ユーザーのみ）
            .td.light
              div
                span.full 無制限
                span.detail （一般ユーザー権限設定有り）
            .td.basic
              div
                span.full 無制限
                span.detail （一般ユーザー権限設定有り）
          .body-line
            .td.item サポート
            .td.free
              div
                span.limited △
                span.detail （システム回答のみ、回答期限無し）
            .td.light
              div
                span.full 〇
                span.detail （2営業日以内に1次回答）
            .td.basic
              div
                span.full 〇
                span.detail （2営業日以内に1次回答）
          .body-line
            .td.item 施設アプリの広告表示
            .td.free 表示有り
            .td.light.full 表示無し
            .td.basic.full 表示無し
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * プラン機能比較詳細モーダル
 */
@Component
export default class PlanFunctionDetailModal extends Vue {
  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }
}
</script>
